<template>
  <div>
    <v-row
      v-if="!this.$store.state.editing"
      class="form-title"
      align="center"
      justify="center"
      ><h2 class="header-title-h2">
        Complimenti per aver trovato un dominio per il tuo sito.
      </h2></v-row
    >
    <div class="form-spacer" />
    <v-row
      v-if="!this.$store.state.editing"
      class="form-title"
      align="center"
      justify="center"
    >
      <h3>
        Il prossimo passo consiste nello scegliere un aspetto grafico fra quelli
        predefiniti disponibili.<BR />E' possibile visualizzare un anteprima
        facendo click su una delle immagini!
      </h3></v-row
    >

    <v-row>
      <v-col>
        <v-card class="mx-auto" max-width="300">
          <v-img
            class="white--text align-end"
            height="300px"
            src="../../assets/colors/1.jpg"
          >
          </v-img>

          <v-card-subtitle class="pb-0">Verde acquamarina</v-card-subtitle>

          <v-card-text class="text--primary">
            <div>Il colore andrà a cambiare gli elementi grafici come:</div>
            <div>Menu, titoli, fondo e loghi</div>
          </v-card-text>

          <v-card-actions>
            <v-row class="text-center" align="center" justify="center">
              <v-btn
                style="margin-right:5px;"
                v-if="!templateSelected"
                @click="previewTemplate(1, $event)"
                color="#b083a8"
                class="white--text"
              >
                ANTEPRIMA </v-btn
              ><v-btn
                v-if="!templateSelected"
                @click="selectTemplate('1', $event)"
                color="primary"
              >
                SELEZIONA
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col>
        <v-card class="mx-auto" max-width="300">
          <v-img
            class="white--text align-end"
            height="300px"
            src="../../assets/colors/2.jpg"
          >
          </v-img>

          <v-card-subtitle class="pb-0">Celeste</v-card-subtitle>

          <v-card-text class="text--primary">
            <div>Il colore andrà a cambiare gli elementi grafici come:</div>
            <div>Menu, titoli, fondo e loghi</div>
          </v-card-text>

          <v-card-actions>
            <v-row class="text-center" align="center" justify="center">
              <v-btn
                style="margin-right:5px;"
                v-if="!templateSelected"
                @click="previewTemplate(2, $event)"
                color="#b083a8"
                class="white--text"
              >
                ANTEPRIMA </v-btn
              ><v-btn
                v-if="!templateSelected"
                @click="selectTemplate('2', $event)"
                color="primary"
              >
                SELEZIONA
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col>
        <v-card class="mx-auto" max-width="300">
          <v-img
            class="white--text align-end"
            height="300px"
            src="../../assets/colors/3.jpg"
          >
          </v-img>

          <v-card-subtitle class="pb-0">Blu</v-card-subtitle>

          <v-card-text class="text--primary">
            <div>Il colore andrà a cambiare gli elementi grafici come:</div>
            <div>Menu, titoli, fondo e loghi</div>
          </v-card-text>

          <v-card-actions>
            <v-row class="text-center" align="center" justify="center">
              <v-btn
                style="margin-right:5px;"
                v-if="!templateSelected"
                @click="previewTemplate(3, $event)"
                color="#b083a8"
                class="white--text"
              >
                ANTEPRIMA </v-btn
              ><v-btn
                v-if="!templateSelected"
                @click="selectTemplate('3', $event)"
                color="primary"
              >
                SELEZIONA
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col>
        <v-card class="mx-auto" max-width="300">
          <v-img
            class="white--text align-end"
            height="300px"
            src="../../assets/colors/4.jpg"
          >
          </v-img>

          <v-card-subtitle class="pb-0">Verde</v-card-subtitle>

          <v-card-text class="text--primary">
            <div>Il colore andrà a cambiare gli elementi grafici come:</div>
            <div>Menu, titoli, fondo e loghi</div>
          </v-card-text>

          <v-card-actions>
            <v-row class="text-center" align="center" justify="center">
              <v-btn
                style="margin-right:5px;"
                v-if="!templateSelected"
                @click="previewTemplate(4, $event)"
                color="#b083a8"
                class="white--text"
              >
                ANTEPRIMA </v-btn
              ><v-btn
                v-if="!templateSelected"
                @click="selectTemplate('4', $event)"
                color="primary"
              >
                SELEZIONA
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col>
        <v-card class="mx-auto" max-width="300">
          <v-img
            class="white--text align-end"
            height="300px"
            src="../../assets/colors/5.jpg"
          >
          </v-img>

          <v-card-subtitle class="pb-0">Neutro</v-card-subtitle>

          <v-card-text class="text--primary">
            <div>Il colore andrà a cambiare gli elementi grafici come:</div>
            <div>Menu, titoli, fondo e loghi</div>
          </v-card-text>

          <v-card-actions>
            <v-row class="text-center" align="center" justify="center">
              <v-btn
                style="margin-right:5px;"
                v-if="!templateSelected"
                @click="previewTemplate(5, $event)"
                color="#b083a8"
                class="white--text"
              >
                ANTEPRIMA </v-btn
              ><v-btn
                v-if="!templateSelected"
                @click="selectTemplate('5', $event)"
                color="primary"
              >
                SELEZIONA
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col>
        <v-card class="mx-auto" max-width="300">
          <v-img
            class="white--text align-end"
            height="300px"
            src="../../assets/colors/6.jpg"
          >
          </v-img>

          <v-card-subtitle class="pb-0">Rosso Bordeaux</v-card-subtitle>

          <v-card-text class="text--primary">
            <div>Il colore andrà a cambiare gli elementi grafici come:</div>
            <div>Menu, titoli, fondo e loghi</div>
          </v-card-text>

          <v-card-actions>
            <v-row class="text-center" align="center" justify="center">
              <v-btn
                style="margin-right:5px;"
                v-if="!templateSelected"
                @click="previewTemplate(6, $event)"
                color="#b083a8"
                class="white--text"
              >
                ANTEPRIMA </v-btn
              ><v-btn
                v-if="!templateSelected"
                @click="selectTemplate('6', $event)"
                color="primary"
              >
                SELEZIONA
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <div style="height:50px" />
    <v-row class="text-center" align="center" justify="center">
      <v-btn
        v-if="!templateSelected && !this.$store.state.editing"
        class="ml-2"
        @click="goBack()"
        color="primary"
        >Indietro</v-btn
      >
      <v-progress-circular
        v-if="templateSelected"
        :indeterminate="true"
        :rotate="0"
        :size="32"
        :width="4"
        color="light-blue"
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import store from "../../store/index";
import config from "../../config";

export default {
  data() {
    return {
      templateSelected: false,
    };
  },

  methods: {
    selectTemplate(name) {
      if (!this.$store.state.editing) {
        this.templateSelected = true;
        let completedStep = this.$store.state.wizard.completedStep;
        if (completedStep < this.$store.state.wizard.selectedStep)
          completedStep = this.$store.state.wizard.selectedStep;

        store
          .dispatch("setWizardSteps", {
            completedStep: completedStep,
            selectedStep: this.$store.state.wizard.selectedStep + 1,
            meta: {
              template: name,
            },
          })
          .then(() => {
            this.templateSelected = false;
          });
      } else {
        store
          .dispatch("setEditingMeta", {
            meta: {
              template: name,
            },
          })
          .then(() => {
            this.$router.push("/");
          });
      }
    },

    previewTemplate(name) {
      let thisURl = window.location.origin;
      let url = thisURl + "/previews/" + config.appPath + "/" + this.$store.state.wizard.meta.feature + "/0" + name + "/index.html";
      window.open(url.replace("/deluxe", "/premium"));
    },

    goBack() {
      this.$store.state.wizard.selectedStep--;
    },
  },
};
</script>

<style scoped>
.header-title-h2 {
  color: #74a2bc;
  font-size: 32px;
  font-weight: 400;
}
</style>
